module.exports = __webpack_public_path__ + "img/FirstAid.7fafc447.gif";